<script setup>
// Term dropdown for schedule pages; pair with useTerm():
//   const { terms, term } = useTerm();
//   <UiTermSelect v-model="term" :items="terms" />
defineProps({
  items: { type: Array, required: true },
});
const term = defineModel({ type: String, default: '' });
</script>

<template>
  <v-select
    v-model="term"
    :items="items"
    prepend-inner-icon="mdi-calendar-range"
    aria-label="Term"
    hide-details
    style="max-width: 200px; width: 100%"
  />
</template>
